import { z } from "zod";

export type Country = z.infer<typeof CountryEnum>;

export const CountryEnum = z.enum(["Norge", "Sverige", "Danmark", "Finland"], {
  message: "Must be one of: Norge, Sverige, Danmark, Finland",
});
